import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const notes = [
  {
    img: '/img/blog-1.jpg',
    title: 'First impression audit',
    excerpt: 'I refine spacing, colors, headings, and calls to action so visitors understand the value quickly.',
    tag: 'Design',
    accent: 'var(--aqua)',
  },
  {
    img: '/img/blog-2.jpg',
    title: 'Responsive build pass',
    excerpt: 'Every section is checked for mobile readability, stable grids, clean buttons, and comfortable content flow.',
    tag: 'Frontend',
    accent: 'var(--rose)',
  },
  {
    img: '/img/blog-3.jpg',
    title: 'Launch polish',
    excerpt: 'I tune metadata, images, forms, hover states, and performance details before the final handoff.',
    tag: 'Launch',
    accent: 'var(--sun)',
  },
];

export default function Blog() {
  const [ref, inView] = useInView({ threshold: 0.05, triggerOnce: true });

  return (
    <section id="blog" ref={ref} className="section-pad">
      <div className="ghost-text">PROCESS</div>

      <div className="section-shell">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          style={{ textAlign: 'center', marginBottom: 58 }}
        >
          <div className="eyebrow" style={{ justifyContent: 'center' }}>How I polish</div>
          <h2 className="section-title">Small details make the site feel expensive.</h2>
        </motion.div>

        <div className="blog-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 18 }}>
          {notes.map((note, index) => (
            <motion.article
              key={note.title}
              initial={{ opacity: 0, y: 32 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.55, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -8 }}
              className="premium-card shine"
              style={{ overflow: 'hidden' }}
            >
              <div style={{ position: 'relative', height: 230, overflow: 'hidden' }}>
                <img
                  src={note.img}
                  alt={`${note.title} for premium web development projects in India`}
                  loading="lazy"
                  decoding="async"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
                <div style={{ position: 'absolute', inset: 0, background: `linear-gradient(to top, rgba(7,7,8,0.86), transparent 60%), linear-gradient(135deg, ${note.accent}, transparent 46%)`, opacity: 0.78 }} />
                <span className="chip" style={{ position: 'absolute', left: 14, top: 14, color: note.accent }}>{note.tag}</span>
              </div>

              <div style={{ padding: 24 }}>
                <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22, lineHeight: 1.16, marginBottom: 12 }}>
                  {note.title}
                </h3>
                <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.75 }}>{note.excerpt}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 960px) { .blog-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
